// must be the same names as the names of breakpoints in _bootstrap-grid.scss
export const viewports = ["xs", "sm", "md", "lg", "xl", "xxl"]

// calculate viewport dimensions
export function getDimensions() {
  const rect = document.body.getBoundingClientRect()

  return {
    height: rect.bottom - rect.top,
    width: rect.right - rect.left
  }
}

export function getScrollOffset() {
  return (
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0
  )
}

export function getViewport() {
  let len = viewports.length

  if (typeof getComputedStyle === "function") {
    const content = window
      .getComputedStyle(document.body, ":after")
      .getPropertyValue("content")

    while (len--) {
      if (content.indexOf(viewports[len]) !== -1) {
        return viewports[len]
      }
    }
  }

  return viewports[0]
}

/**
 * Calculate the amount of px an element (height) is in viewport
 *
 * @param el
 * @return {number}
 */
export function inViewport(el) {
  const w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName("body")[0],
    H = w.innerHeight || e.clientHeight || g.clientHeight,
    elH = el.offsetHeight,
    r = el.getBoundingClientRect(),
    t = r.top,
    b = r.bottom

  return Math.max(0, t > 0 ? Math.min(elH, H - t) : Math.min(b, H))
}
